import { FC } from "react";

type TextPreloaderProps = {
  loaded: boolean;
};

export const TextPreloader: FC<React.PropsWithChildren<TextPreloaderProps>> = ({
  loaded,
  children,
}) =>
  loaded ? <span className="animate-pulse">{children}</span> : <>{children}</>;
